module.exports = __webpack_public_path__ + "static/media/reload.e3beadb4.svg";